const selectors = {
  button: '[data-styled-button]',
};

const handleButtonClick = (event) => {
  const button = event.target.closest(selectors.button);

  if (!button) return;

  const circle = document.createElement('span');
  const diameter = Math.max(button.clientWidth, button.clientHeight);
  const radius = diameter / 2;

  const buttonOffset = button.getBoundingClientRect();

  circle.style.width = `${diameter}px`;
  circle.style.height = `${diameter}px`;
  circle.style.left = `${event.pageX - window.scrollX - (buttonOffset.left + radius)}px`;
  circle.style.top = `${event.pageY - window.scrollY - (buttonOffset.top + radius)}px`;
  circle.classList.add('ripple');

  const ripple = button.getElementsByClassName('ripple')[0];

  if (ripple) {
    ripple.remove();
  }

  button.appendChild(circle);
};

const buttonController = {
  init() {
    document.addEventListener('click', handleButtonClick);
  },
};

export default buttonController;
